import type { KeyboardEvent } from 'react';

import { focusElement } from './FocusElement';
import { getMoreToolbarStartAndEndButtons } from './GetMoreToolbarStartAndEndButtons';
import { getStartAndEndButtons } from './GetStartAndEndButtons';
import { isMovingFromElement } from './IsMovingFromElement';

type CircularFocusHandlererParams =
  | {
      e: KeyboardEvent<HTMLDivElement>;
      firstButtonDataHook: string;
      lastButtonDataHook: string;
    } & (
      | {
          isMoreModalOpen: true;
          moreModalFirstButtonDataHook: string;
          moreModalLastButtonDataHook: string;
          moreButton: HTMLButtonElement;
        }
      | {
          isMoreModalOpen?: false;
          moreButton?: HTMLButtonElement | null;
        }
    );

export const circularFocusHandlerer = ({
  e,
  firstButtonDataHook,
  lastButtonDataHook,
  ...moreModalProps
}: CircularFocusHandlererParams) => {
  const isTabPressed = e.key === 'Tab';

  if (!isTabPressed) {
    return;
  }

  const isGoingBackwards = e.shiftKey;
  const isGoingForwards = !isGoingBackwards;

  const main = getStartAndEndButtons({
    startButtonDataHook: firstButtonDataHook,
    endButton: moreModalProps.moreButton ? moreModalProps.moreButton : lastButtonDataHook,
  });

  if (!moreModalProps.isMoreModalOpen) {
    if (isGoingForwards && isMovingFromElement(main.end)) {
      focusElement(main.start, e);
    }

    if (isGoingBackwards && isMovingFromElement(main.start)) {
      focusElement(main.end, e);
    }
    return;
  }

  const more = getMoreToolbarStartAndEndButtons({
    startButtonDataHook: moreModalProps.moreModalFirstButtonDataHook,
    endButton: moreModalProps.moreModalLastButtonDataHook,
  });

  if (isGoingForwards && isMovingFromElement(more.end)) {
    focusElement(main.start, e);
  }

  if (isGoingBackwards && isMovingFromElement(main.start)) {
    focusElement(more.end, e);
  }
};
